<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.value" class="tab" :class="{active: activeTab === tab.value}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <button type="button" class="refresh-btn" @click="onRefresh" :disabled="loading">刷新</button>
    </div>
    
    <!-- 筛选区 -->
    <div class="search-section search-section-new">
      <form class="search-form-2x2">
        <div class="form-fields">
          <div class="form-item">
            <label>设备编号：</label>
            <select class="form-input" v-model="query.deviceNo">
              <option value="">全部</option>
              <option v-for="device in deviceOptions" :key="device" :value="device">
                {{ device }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>设备位置：</label>
            <select class="form-input" v-model="query.deviceLocation">
              <option value="">全部</option>
              <option v-for="location in deviceLocationOptions" :key="location" :value="location">
                {{ location }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>洗衣程序：</label>
            <select class="form-input" v-model="query.laundry_program">
              <option value="">全部</option>
              <option value="桶自洁">桶自洁</option>
              <option value="单脱水">单脱水</option>
              <option value="快洗">快洗</option>
              <option value="标准洗">标准洗</option>
              <option value="大件洗">大件洗</option>
            </select>
          </div>
          <div class="form-item">
            <label>员工姓名：</label>
            <select class="form-input" v-model="query.user_name">
              <option value="">全部</option>
              <option v-for="name in customerNameOptions" :key="name" :value="name">
                {{ name }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>开始日期：</label>
            <input class="form-input" type="date" v-model="query.start_date" placeholder=" " />
          </div>
          <div class="form-item">
            <label>结束日期：</label>
            <input class="form-input" type="date" v-model="query.end_date" placeholder="" />
          </div>
        </div>
        <div class="form-btns">
          <button type="button" class="search-btn-green" @click="onSearch" :disabled="loading">搜索</button>
          <!-- <button type="button" class="search-btn-green" @click="printData">打印</button> -->
          <button type="button" class="clear-btn" @click="onClear" :disabled="loading">清空</button>
        </div>
      </form>
    </div>
    
    <!-- 表格 -->
    <div class="data-section">
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>订单ID</th>
              <th>订单号</th>
              <th>员工姓名</th>
              <th>设备编号</th>
              <th>设备位置</th>
              <th>洗衣程序</th>
              <th>下单时间</th>
              <th>洗衣开始时间</th>
              <th>洗衣结束时间</th>
              <th>取衣时间</th>
              <th>超时状态</th>
              <th>投诉状态</th>
              <th>订单状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="14" style="text-align:center;color:#bbb;">数据加载中...</td>
            </tr>
            <tr v-else-if="orderList.length === 0">
              <td colspan="14" style="text-align:center;color:#bbb;">暂无数据</td>
            </tr>
            <template v-else>
              <tr v-for="(order, index) in orderList" :key="order.order_id">
                <td>{{ ((pagination.page - 1) * pagination.pageSize) + index + 1 }}</td>
                <td>{{ order.order_id }}</td>
                <td>{{ order.order_no }}</td>
                <td>{{ order.user_name }}</td>
                <td>{{ order.device_no }}</td>
                <td>{{ order.device_location }}</td>
                <td>{{ order.program_name }}</td>
                <td>{{ order.order_time || '-'}}</td>
                <td>{{ order.wash_start_time || '-'}}</td>
                <td>{{ order.wash_end_time || '-'}}</td>
                <td>{{ order.taken_time || '-' }}</td>
                <td>
                  <span :class="order.is_take_timeout ? 'text-red' : 'text-green'">
                    {{ order.is_take_timeout ? '是' : '否' }}
                  </span>
                </td>
                <td>
                  <span :class="order.has_complaint ? 'text-red' : 'text-green'">
                    {{ order.has_complaint ? '是' : '否' }}
                  </span>
                </td>
                <td>
                  <span class="status-badge" :class="getStatusClass(order.status)">
                    {{ order.status }}
                  </span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination" v-if="pagination.total > 0">
        <button class="page-btn" :disabled="pagination.page===1" @click="changePage(1)">«</button>
        <button class="page-btn" :disabled="pagination.page===1" @click="changePage(pagination.page-1)">&lt;</button>
        <span v-for="p in pagination.displayPages" :key="p">
          <button v-if="p !== '...'" class="page-btn" :class="{active:pagination.page===p}" @click="changePage(p)">{{p}}</button>
          <span v-else class="page-ellipsis">...</span>
        </span>
        <button class="page-btn" :disabled="pagination.page===pagination.totalPages" @click="changePage(pagination.page+1)">&gt;</button>
        <button class="page-btn" :disabled="pagination.page===pagination.totalPages" @click="changePage(pagination.totalPages)">»</button>
        <div class="page-jump">
          <input type="text" v-model.number="pagination.pageInput" style="width:50px;"/>
          <button class="jump-btn" @click="jumpPage">跳转</button>
          <span style="margin-left:10px;">共{{pagination.total}}条数据</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { listOrders } from '@/api/laundry';
import { 
  validateDateRange1, 
  formatDate,
  getDateRange 
} from '@/api/dateValidator';

export default {
  name: 'LaundryOrderManagement',
  data() {
    return {
      // 标签页配置
      tabs: [
        { label: '全部', value: '' },
        { label: '准备中', value: '准备中' },
        { label: '洗衣中', value: '洗衣中' },
        { label: '已完成', value: '已完成' },
        { label: '待取衣', value: '待取衣' },
        { label: '已取消', value: '已取消' }
      ],
      // tabs: [
      //   { label: '全部', value: '' },
      //   { label: '准备中', value: '准备中' },
      //   { label: '洗衣中', value: '洗衣中' },
      //   { label: '已完成', value: '已完成' },
      //   { label: '待取衣', value: '待取衣' },
      //   { label: '已取消', value: '已取消' },
      //   { label: '投诉中', value: '投诉中' }
      // ],
      activeTab: '',
      
      loading: false,

      // 分页参数 
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        displayPages: [],
        pageInput: 1
      },

      // 订单列表数据
      orderList: [],
      
      // 查询条件
      query: {
        status: '',
        laundry_program: '',
        user_name: '',
        deviceNo: '',
        deviceLocation: '',
        start_date: '',
        end_date: ''
      },
      
      // 防抖计时器
      debounceTimer: null,
      
      // 用于前端筛选的选项（从接口数据中提取）
      deviceOptions: [],
      customerNameOptions: [],
      deviceLocationOptions: [],
    }
  },
  
  computed: {
    // 计算总页数
    totalPagesCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize) || 1;
    }
  },
  
  watch: {
    // 监听查询条件中的日期变化
    'query.start_date': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleDateChange();
      }
    },
    'query.end_date': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleDateChange();
      }
    },
    
    // 监听总页数变化，更新显示页码
    totalPagesCount: {
      handler(newVal) {
        this.pagination.totalPages = newVal;
        this.updateDisplayPages();
      },
      immediate: true
    },

    // 监听当前页码变化，更新显示页码
    'pagination.page': function() {
      this.updateDisplayPages();
    }
  },

  mounted() {
    // 初始化加载数据
    this.fetchOrders();
    this.fetchFilterOptions(); // 获取所有筛选选项
  },

  methods: {
    // 处理日期变化（防抖）
    handleDateChange() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      
      this.debounceTimer = setTimeout(() => {
        const result = validateDateRange1(
          { startDate: this.query.start_date, endDate: this.query.end_date }, 
          { maxDays: 365 }
        );
        
        if (!result.isValid) {
          this.showMessage(result.message);
          if (result.autoCorrected) {
            this.query.start_date = result.correctedDateRange.startDate;
            this.query.end_date = result.correctedDateRange.endDate;
          }
        }
      }, 500);
    },
    
    // 获取日期范围内的所有日期
    getDateList() {
      if (this.query.start_date && this.query.end_date) {
        return getDateRange(this.query.start_date, this.query.end_date);
      }
      return [];
    },
    
    // 格式化日期显示
    formatDateForDisplay(date) {
      return formatDate(date);
    },

    // 更新显示的页码
    updateDisplayPages() {
      const pages = [];
      const total = this.pagination.totalPages;
      const current = this.pagination.page;
      
      if (total <= 7) {
        // 总页数小于等于7，显示所有页码
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // 总页数大于7，显示部分页码
        if (current <= 4) {
          // 当前页码在前4页
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          // 当前页码在后4页
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          // 当前页码在中间
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }
      
      this.pagination.displayPages = pages;
    },

    // 新增：获取所有筛选选项
    async fetchFilterOptions() {
      try {
        // 调用接口获取所有设备编号和员工姓名
        // 使用较大的 pageSize 来获取足够多的数据
        const params = {
          pageSize: 1000, // 获取前1000条数据，通常足够覆盖所有选项
          pageNo: 1
        };
        
        const response = await listOrders(params);
        const res = response.data;
        
        if (res.code === 0) {
          const { list = [] } = res.data || {};
          const devices = new Set();
          const names = new Set();
          const locations = new Set();
          
          list.forEach(order => {
            if (order.device_no) devices.add(order.device_no);
            if (order.user_name) names.add(order.user_name);
            if (order.device_location) locations.add(order.device_location);

          });
          
          this.deviceOptions = Array.from(devices).sort();
          this.customerNameOptions = Array.from(names).sort();
          this.deviceLocationOptions = Array.from(locations).sort();
          
          console.log('筛选选项加载完成:', {
            deviceCount: this.deviceOptions.length,
            nameCount: this.customerNameOptions.length,
            locationCount: this.deviceLocationOptions.length
          });
        }
      } catch (error) {
        console.error('获取筛选选项失败:', error);
      }
    },

    // 获取订单列表接口
    async fetchOrders() {
      try {
        this.loading = true;
        
        // 验证日期范围
        if (this.query.start_date || this.query.end_date) {
          const validationResult = validateDateRange1(
            { startDate: this.query.start_date, endDate: this.query.end_date }, 
            { maxDays: 365 }
          );
          if (!validationResult.isValid) {
            this.showMessage(validationResult.message);
            if (validationResult.autoCorrected) {
              this.query.start_date = validationResult.correctedDateRange.startDate;
              this.query.end_date = validationResult.correctedDateRange.endDate;
            }
            return;
          }
        }
        
        // 构建查询参数
        const params = {
          pageNo: this.pagination.page,
          pageSize: this.pagination.pageSize,
          //设备编号
          device_no: this.query.deviceNo || undefined,
          //设备位置
          device_location: this.query.deviceLocation || undefined,
          //员工姓名
          user_name: this.query.user_name || undefined,
          // 状态筛选
          status: this.query.status || undefined,
          // 洗衣程序筛选
          laundry_program: this.query.laundry_program || undefined,
          // 日期范围筛选
          start_date: formatDate(this.query.start_date) || undefined,
          end_date: formatDate(this.query.end_date )|| undefined,
        };
        
        // 调用API获取数据
        const response = await listOrders(params);
        const res = response.data;
        
        if (res.code === 0) {
          const { list = [], total = 0, pageNo, pageSize } = res.data || {};
          this.orderList = list;
          this.pagination.total = total;
          this.pagination.page = pageNo || 1;
          this.pagination.pageSize = pageSize || 10;
          
          // 计算总页数并更新
          this.pagination.totalPages = Math.ceil(total / this.pagination.pageSize) || 1;
          
          console.log('获取数据成功:', { total, listLength: list.length });
        } else {
          this.showMessage(res.message || '获取数据失败');
          this.orderList = [];
          this.pagination.total = 0;
          this.pagination.totalPages = 1;
        }
      } catch (error) {
        console.error('获取订单列表失败:', error);
        this.showMessage('获取数据异常，请稍后重试');
        this.orderList = [];
        this.pagination.total = 0;
        this.pagination.totalPages = 1;
      } finally {
        this.loading = false;
      }
    },
    
    // 搜索功能
    async onSearch() {
      this.pagination.page = 1; // 重置到第一页
      this.pagination.pageInput = 1;
      await this.fetchOrders();
      await this.fetchFilterOptions(); // 搜索后刷新筛选选项
    },
    
    // 清空筛选条件
    async onClear() {
      // 重置查询条件
      this.query = {
        status: '',
        laundry_program: '',
        user_name: '',
        deviceNo: '',
        deviceLocation: '',
        start_date: '',
        end_date: ''
      };
      this.activeTab = '';
      
      this.pagination.page = 1;
      this.pagination.pageInput = 1;
      await this.fetchOrders();
      await this.fetchFilterOptions(); // 清空后刷新筛选选项
    },
    
    // 切换标签页
    async switchTab(tab) {
      this.activeTab = tab.value;
      this.query.status = tab.value;
      this.pagination.page = 1;
      this.pagination.pageInput = 1;
      await this.fetchOrders();
      await this.fetchFilterOptions(); // 切换标签后刷新筛选选项
    },
    
    // 刷新功能
    async onRefresh() {
      await this.fetchOrders();
      await this.fetchFilterOptions(); // 刷新后刷新筛选选项
    },
    
    // 分页相关方法
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.pagination.totalPages) {
        this.pagination.page = newPage;
        this.pagination.pageInput = newPage;
        this.fetchOrders();
      }
    },
    
    jumpPage() {
      let targetPage = parseInt(this.pagination.pageInput);
      if (isNaN(targetPage) || targetPage < 1) targetPage = 1;
      else if (targetPage > this.pagination.totalPages) targetPage = this.pagination.totalPages;
      this.changePage(targetPage);
    },

    // 获取状态样式类
    getStatusClass(status) {
      const statusMap = {
        '准备中': 'status-ready',
        '洗衣中': 'status-washing',
        '已完成': 'status-completed',
        '待取衣': 'status-waiting',
        '已取消': 'status-cancelled',
        '投诉中': 'status-complaint'
      };
      return statusMap[status] || 'status-pending';
    },
    
    // 打印功能
    // printData() {
    //   window.print();
    // },
    
    // 消息提示
    showMessage(message) {
      alert(message);
    }
  },
  
  // 组件销毁前清理计时器
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
}
</script>

<style scoped>
/* 主容器 - 消除滚动条 */
/* div {
  box-sizing: border-box;
  overflow: hidden; 
} */
 div {
  box-sizing: border-box;
 
}
.text-red {
  color: red;
}
.text-green {
  color: green;
}
</style>